<template>
  <div class="Develop">
    <div class="des">개발자페이지</div>
    <a href="#" @click="getNavigator()">navigator</a>
    <a href="#" @click="getWindow()">window</a>
    <el-input v-model="username"></el-input>
    <el-input v-model="password"></el-input>
    <a href="#" @click="Login()">Login</a>
    <ul class="windowList">
      <li v-for="(item, index) in list" :key="index">
        {{ item }}
      </li>
    </ul>
  </div>
</template>

<script>
const tjs = require('teslajs')
export default {
  name: "Develop",
  data() {
    return {
      address: "",
      list:[],
      username : 'kang3d@daum.net',
      password : '',
      mfaPassCode : '',
      client_id : "81527cff06843c8634fdc09e8ac0abefb46ac849f38fe1e431c2ef2106796384",
      client_secret : "c7257eb71a564034f9419ee651c7d0e5f7aa6bfbd18bafb5c5c033b093bb2fa3",
      baseURL: 'https://owner-api.teslamotors.com'
    };
  },
  mounted() {
    this.getNavigator()
  },
  methods: {
    Login() {
      fetch( this.baseURL + '/oauth/token', 
      {
        mode: 'no-cors',
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*'
        },
        body: JSON.stringify({
          grant_type    : 'password',
          client_id     : this.client_id,
          client_secret : this.client_secret,
          email         : this.username,
          password      : this.password,
        })
      })
      .then((response) => console.log(response));
      // .then( ( r ) => r.json())
      // .then( ( response ) => {
      //   console.log(response);
      // }).catch( ( error ) => {
      //   console.log(error);
      // });

    
    },
    getNavigator(){
      this.list = [];
      for( var n in navigator){
        this.list.push(n + ' : ' + navigator[n] )
      }
      console.log(navigator.usb)
    },
    getWindow(){
      this.list = [];
      for( var n in window){
        this.list.push(n + ' : ' + window[n] )
      }
    },
    go() {
      var tmpURL = this.address;
      if (tmpURL != "") {
        location.href = "https://www.youtube.com/redirect?q=" + tmpURL;
      } else {
        alert("Please check the URL.");
        this.$refs.address.focus();
      }
    }
  }
};
</script>

<style scoped>
.Develop {
  position: relative;
}

.windowList{
  color:#EEEEEE; text-align: left; font-size:14px;
  line-height: 200%;
}
div.des {
  color: #666666;
  transform: rotate(-0.03deg);
  margin-top: 30px;
  letter-spacing: -0.5px;
}

div.Economy input {
  height: 50px;
  width: 800px;
  border: 1px solid #333333;
  margin-bottom: 40px;
  font-size: 20px;
  text-align: center;
  letter-spacing: -0.5px;
  transform: rotate(-0.028deg);
  border-radius: 5px;
  background-color: #ff3333;
  color: #ffffff;
  outline: none;
  font-weight: 200;
}

div.Economy input::placeholder {
  color: rgba(255, 255, 255, 0.6);
  font-weight: 200;
}
</style>



// WEBPACK FOOTER //
// src/pages/Develop/index.vue